import { getAnalytics, logEvent } from "firebase/analytics";
import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyC1UcyckwELWuxrtnCDigL_XjwI9Xm_BD4",
  authDomain: "aitoolkit-production.firebaseapp.com",
  projectId: "aitoolkit-production",
  storageBucket: "aitoolkit-production.appspot.com",
  messagingSenderId: "162501268112",
  appId: "1:162501268112:web:2b3b241da22f1b44eabe15",
  measurementId: "G-JBRSDMZCPN",
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export const logAnalyticsEvent = (eventName) => {
  logEvent(analytics, eventName);
};
